module.exports = __webpack_public_path__ + "images/92d5b04c.img3-usa.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img3-usa.png
// module id = 406
// module chunks = 0